// extracted by mini-css-extract-plugin
export default {"header":"EmptyHeader_header__bZelG","logo":"EmptyHeader_logo__L8XTG","select":"EmptyHeader_select__Hip7h"};